import { string, object, ref } from "yup";

export const setPasswordValidationSchema = object().shape({
    password: string().required("Password is required"),
    passwordConfirmation: string()
        .required("password Confirmation is required")
        .oneOf([ref("password")], "Passwords must match"),
});
